if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', class CountdownTimer extends HTMLElement {
    constructor() {
      super();

      const endDateStr = this.getAttribute('data-end-date');
      this.endDate = CountdownTimer.parseEndDate(endDateStr);
      this.idFor = this.dataset.blockId || this.dataset.timerFor || '';
      this.timeInterval = null;

      if (!this.endDate) {
        this.hidden = true;
        return;
      }

      const total = this.endDate.getTime() - Date.now();
      if (total <= 0) {
        this.hidden = true;
        return;
      }

      this.init();
    }

    init() {
      this.renderCountdown(this.getCountdownTime());

      this.timeInterval = setInterval(() => {
        const countdownTime = this.getCountdownTime();
        this.renderCountdown(countdownTime);

        if (countdownTime.total <= 0) {
          clearInterval(this.timeInterval);
          this.timeInterval = null;
          this.hidden = true;
          document.dispatchEvent(new CustomEvent(`countdownEnded-${this.idFor}`));
        }
      }, 1000);
    }

    getCountdownTime() {
      const total = this.endDate.getTime() - Date.now();
      const totalSeconds = Math.max(0, Math.floor(total / 1000));
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      return {
        total,
        days,
        hours,
        minutes,
        seconds,
      };
    }

    renderCountdown(countdownTime) {
      const daysElement = this.querySelector('[data-countdown-days]');
      const hoursElement = this.querySelector('[data-countdown-hours]');
      const minutesElement = this.querySelector('[data-countdown-minutes]');
      const secondsElement = this.querySelector('[data-countdown-seconds]');

      if (daysElement) daysElement.textContent = CountdownTimer.pad(countdownTime.days);
      if (hoursElement) hoursElement.textContent = CountdownTimer.pad(countdownTime.hours);
      if (minutesElement) minutesElement.textContent = CountdownTimer.pad(countdownTime.minutes);
      if (secondsElement) secondsElement.textContent = CountdownTimer.pad(countdownTime.seconds);
    }

    disconnectedCallback() {
      if (this.timeInterval) {
        clearInterval(this.timeInterval);
        this.timeInterval = null;
      }
    }

    /**
     * Parse YYYY-MM-DD and return end of that day (23:59:59) in local time as Date.
     * @param {string} dateStr - Date string YYYY-MM-DD
     * @returns {Date|null}
     */
    static parseEndDate(dateStr) {
      if (!dateStr || typeof dateStr !== 'string') return null;
      const parts = dateStr.trim().split('-');
      if (parts.length !== 3) return null;
      const y = parseInt(parts[0], 10);
      const m = parseInt(parts[1], 10) - 1;
      const d = parseInt(parts[2], 10);
      if (isNaN(y) || isNaN(m) || isNaN(d)) return null;
      const date = new Date(y, m, d, 23, 59, 59, 999);
      if (isNaN(date.getTime())) return null;
      return date;
    }

    /**
     * Pad number to 2 digits.
     * @param {number} n
     * @returns {string}
     */
    static pad(n) {
      return (n < 10 ? '0' : '') + n;
    }
  });
}
